import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import {
  addCaseTypeDropList,
  addOrderTypeDropList,
} from "../../../../Redux/List/Action";
import CaseApi from "Service/Case.api";
import { FormatDropdownData } from "Utils/Common";
import { GlobalResType } from "DataTypes/Common";

const CaseManagement: FC = () => {
  const dispatch = useDispatch();

  // useEffect(() => {
  //   getCaseTypes();
  //   getOrderTypes();
  // }, []);

  // const getCaseTypes: () => void = async () => {
  //   const res: GlobalResType = await CaseApi.fetchCaseTypes();
  //   if (res?.success) {
  //     dispatch(
  //       addCaseTypeDropList(FormatDropdownData(res?.data, "id", "name", "id"))
  //     );
  //   }
  // };
  // const getOrderTypes: () => void = async () => {
  //   const res: GlobalResType = await CaseApi.fetchOrderTypes();
  //   if (res?.success) {
  //     dispatch(
  //       addOrderTypeDropList(
  //         FormatDropdownData(res?.data, "id", "name", "id")
  //       )
  //     );
  //   }
  // };

  return <Outlet />;
};
export default CaseManagement;
